import { ref, type Ref } from "vue";
import { onBeforeRouteLeave } from "vue-router";

// Shared, module-level state for the global confirmation dialog.
const isOpen = ref(false);
let pendingResolve: ((leave: boolean) => void) | null = null;

const resolvePending = (leave: boolean) => {
  isOpen.value = false;
  const resolve = pendingResolve;
  pendingResolve = null;
  resolve?.(leave);
};

export function useUnsavedChangesDialog() {
  return {
    isOpen,
    confirmLeave: () => resolvePending(true),
    cancelLeave: () => resolvePending(false),
  };
}

export function useUnsavedChangesGuard(hasUnsavedChanges: Ref<boolean>) {
  onBeforeRouteLeave(() => {
    if (!hasUnsavedChanges.value) return true;
    isOpen.value = true;
    return new Promise<boolean>((resolve) => {
      pendingResolve = resolve;
    });
  });
}
